import moment from 'moment';

import QueryParser from '@/js/libs/QueryParser';
import appRouter from '@/js/helpers/app-router';

export default class DocumentLogs {
    constructor(publication, document, http, gate, useQuery) {
        this.queryParser = useQuery
            ? new QueryParser('document-logs-' + document.id)
            : null;

        this.publication = publication;
        this.document = document;
        this.gate = gate;
        this.http = http;
    }

    get isLoading() {
        return this.http.isLoading;
    }

    canBrowse() {
        return this.gate.allow('browse', 'log', this.document);
    }

    canAdd() {
        return this.gate.allow('add', 'log', this.document);
    }

    index(payload) {
        const url = appRouter('api.publications.documents.logs.index', {
            publication: this.publication.id_cpub,
            document: this.document.code,
        });

        const params = this.queryParser && this.queryParser.parse(payload) || payload;

        return this.http.get(url, {params})
            .then((response) => {
                const collection = response.data.data;
                const meta = response.data.meta || {};

                return {collection, meta};
            });
    }

    create() {
        return {
            id: 0,

            type: null,
            message: '',
            payload: null,

            created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
    }

    store(data) {
        const url = appRouter('api.publications.documents.logs.store', {
            publication: this.publication.id_cpub,
            document: this.document.code,
        });

        return this.http.post(url, data)
            .then((response) => response.data.data);
    }
}
